<template>
  <button class="rumie-button" :class="buttonClass" @click="$emit('click')"><slot></slot></button>
</template>

<script>
export default {
  name: "RumieButton",
  props: {
    secondary: Boolean,
    tertiary: Boolean
  },
  computed: {
    buttonClass() {
      return {
        "rumie-button--secondary": this.secondary,
        "rumie-button--tertiary": this.tertiary
      };
    }
  }
};
</script>

<style scoped>
.rumie-button {
  font-weight: var(--bold);
  background: var(--primary);
  background: var(--primary-gradient);
  color: var(--white);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-2) var(--spacing-5);
  cursor: pointer;
  border: none;
  box-sizing: border-box;
  white-space: nowrap;
}

.rumie-button:hover {
  box-shadow: var(--shadow-primary);
}

.rumie-button:disabled {
  cursor: not-allowed;
  opacity: var(--opacity-50);
  box-shadow: none;
}

.rumie-button--secondary {
  background: var(--white);
  color: var(--primary);
  border: var(--border-2) solid var(--primary);
}

.rumie-button--tertiary {
  background: var(--white);
  color: var(--tertiary);
  border: var(--border-2) solid var(--tertiary);
}
</style>
